import type {
  PatchRequestViewModel,
  PatchResultRequest,
  PatchResultResponse,
  PatchResultViewModel,
  Revision,
  RevisionListResponse,
  RevisionListViewModel,
  RevisionUser,
  RevisionUserViewModel,
  RevisionViewModel,
} from "@models/revision";
import { buildMappingResultRow } from "./mappingResult";

export const buildRevisionUserViewModel = (
  user: RevisionUser,
): RevisionUserViewModel => ({ ...user });

export const buildRevisionViewModel = (
  revision: Revision,
): RevisionViewModel => ({
  revisionId: revision.revision_id,
  jobId: revision.job_id,
  rowIndex: revision.row_index,
  reviewStatus: revision.review_status,
  chosenRank: revision.chosen_rank ?? null,
  reason: revision.reason ?? null,
  source: revision.source,
  restoredFrom: revision.restored_from ?? null,
  editedBy: buildRevisionUserViewModel(revision.edited_by),
  editedAt: revision.edited_at,
});

export const buildPatchResultViewModel = (
  response: PatchResultResponse,
): PatchResultViewModel => ({
  revision: buildRevisionViewModel(response.revision),
  row: buildMappingResultRow(response.row),
});

export const buildRevisionListViewModel = (
  response: RevisionListResponse,
): RevisionListViewModel => ({
  revisions: response.revisions.map(buildRevisionViewModel),
  cursor: response.cursor,
});

export const buildPatchRequest = (
  payload: PatchRequestViewModel,
): PatchResultRequest => {
  const request: PatchResultRequest = {
    review_status: payload.reviewStatus,
  };
  if (payload.chosenRank !== undefined) request.chosen_rank = payload.chosenRank;
  if (payload.reason !== undefined) request.reason = payload.reason;
  if (payload.text !== undefined) request.text = payload.text;
  return request;
};
